import { SwitchInput } from '@calendly/ui/components/switch-input';
import { Tooltip } from '@calendly/ui/components/tooltip';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useProductRefreshPreviewToggle } from 'features/app_shell/useProductRefreshPreviewToggle';
const rootCss = "rwm749w";
const helpIconCss = "h1r3tkkk";
const HELP_TOOLTIP_TEXT = 'Product Refresh Preview. Experience the new app shell and Brand 2026 theme, currently under active development.';

/**
 * Dev-only: fixed bottom-left toggle. Turning it on is required (with feature flags) for the new shell and theme.
 * See `useProductRefreshAppShell` / `useProductRefreshUiTheme`.
 */
export function ProductRefreshPreviewToggle() {
  const {
    checked,
    onChange
  } = useProductRefreshPreviewToggle();
  return <div className={rootCss} data-testid="app-layout-debug-switch">
      <label>
        <SwitchInput aria-label="Product refresh layout and Brand 2026 theme" checked={checked} onChange={onChange} />
      </label>
      <Tooltip text={HELP_TOOLTIP_TEXT} zIndex={350}>
        <span className={helpIconCss}>
          <UiIcon name="help-square-rounded" size="small" />
        </span>
      </Tooltip>
    </div>;
}

require("./ProductRefreshPreviewToggle.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProductRefreshPreviewToggle.tsx");